import React, { FC } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { PatientContextProvider } from '../contexts/patient-context';
import { AuthProvider } from '../contexts';
import { environment } from '../environments/environment';
import { ParentProps } from '../models';
import { PaymentSubmissionContextProvider } from '../contexts/payment-submissions-context';
import { LoadingSpinnerProvider } from '../contexts/loading-spinner-context';
import { TranslationProvider } from './translation';

export const GlobalProvider: FC<ParentProps> = (props) => {
  const {
    children,
  } = props;

  return (
    <TranslationProvider>
      <LoadingSpinnerProvider>
        <Auth0Provider
          domain={environment.auth0Domain}
          clientId={environment.auth0ClientId}
          redirectUri={window.location.origin}
          audience={environment.auth0Audience}
          organization={environment.auth0Organization}
        >
          <PatientContextProvider>
            <AuthProvider>
              <PaymentSubmissionContextProvider>
                {children}
              </PaymentSubmissionContextProvider>
            </AuthProvider>
          </PatientContextProvider>
        </Auth0Provider>
      </LoadingSpinnerProvider>
    </TranslationProvider>
  );
};
